export default {"src":"/_next/static/media/360-animation.dbabc873.gif","height":600,"width":800,"blurWidth":0,"blurHeight":0};